import { PageLoader } from '@/components'
import { AuthenticatedOutlet } from '@/providers'
import { useCurrentPatient } from '@/services'
import { Navigate } from 'react-router-dom'

export const ChatEnabledGuard = () => {
  const { data, isLoading } = useCurrentPatient()

  if (isLoading) return <PageLoader />

  // `=== false`: ein fehlendes Feld (aelteres Backend) darf den Chat nicht deaktivieren.
  if (data?.chat_enabled === false) return <Navigate to="../dashboard" replace />

  // AuthenticatedOutlet (statt Outlet), damit der über useOutletContext
  // weitergereichte Auth-Kontext nicht abreißt – sonst crasht die Kindseite.
  return <AuthenticatedOutlet />
}
